import {installGlobalErrorReporting} from "@/shared/errorReporting";

// Install global error handlers before the modules below run their initialization.
installGlobalErrorReporting();

import "./webComponents";
import "./pages";
import "./sidebar";
import "./globalListeners";
import "./messages";
import "./globals";
